import { FormGroup, FormControl } from '@angular/forms';
import { OnInit, Input, Output, EventEmitter, Component } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';
import { OpcionesListaChequeo } from './../../models/formulario-dinamico.model';

@Component({
  selector: 'iw-button-download',
  templateUrl: './radio-buttons-check-list.component.html',
  styleUrls: ['./radio-buttons-check-list.component.scss']
})
export class RadioButtonsCheckListComponent implements ViewCell, OnInit {
  // entrada del valor del boton
  @Input() value: number;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // Opciones de chequeo
  protected _options: OpcionesListaChequeo[] = [];
  // Agrupacion de los radio buttons
  form = new FormGroup({
    option: new FormControl(),
  });
  // salida del cambio del radioButton
  @Output() save: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.form.controls['option'].setValue(this.value);
    if (this.rowData.finish || this.rowData.block) {
      this.form.controls['option'].disable();
    }
    this.form.valueChanges.subscribe(data => {
      this.onClick();
    });
  }

  set options(o: OpcionesListaChequeo[]) {
    this._options = o;
  }

  get options(): OpcionesListaChequeo[] {
    return this._options;
  }

  /**
   * Emite el evento retornando la data de la fila selecionada y el cambio del check
   *
   * @memberof RadioButtonsCheckListComponent
   */
  onClick() {
    if (!this.form.controls['option'].disabled) {
      this.save.emit({ row: this.rowData, value: this.form.controls['option'].value});
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/radio-buttons-check-list/radio-buttons-check-list.component.ts